import BackButton from "@components/TopBar/BackButton";
import HelpButton from "@components/TopBar/HelpButton";
import InboxButton from "@components/TopBar/InboxButton";
import SearchButton from "@components/TopBar/SearchButton";
import SettingsButton from "@components/TopBar/SettingsButton";
import ViewAppButton from "@components/TopBar/ViewAppButton.web";

export const BUTTONS = {
  back: <BackButton />,
  settings: <SettingsButton />,
  inbox: <InboxButton />,
  search: <SearchButton />,
  intercom: <HelpButton />,
  "view-app": <ViewAppButton />,
};
